/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import {getKvalitetMaterijalaDropdown} from '../../api'
import {Option} from '../../models/Sektor'

// KvalitetMaterijalaDropdown Props for the component
interface DropdownProps {
  value?: string | number
  initialValue?: string | number
  onChange?: (name: string, value: any) => void
  errors?: string | undefined
  touched?: boolean
  selectName?: string
  disabled?: boolean
}

const KvalitetMaterijalaDropdown: React.FC<DropdownProps> = ({
  value,
  initialValue,
  onChange,
  errors,
  touched,
  selectName,
  disabled
}) => {
  const [kvalitetMaterijalaDropdown, setKvalitetMaterijalaDropdown] = useState<Array<Option>>([])
  const internalValue = initialValue ?? null

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getKvalitetMaterijalaDropdown()
        setKvalitetMaterijalaDropdown(mapData(response.data))

      } catch (error) {
        console.error('Error fetching Kvalitet Materijala dropdown data:', error)
      }
    }
    fetchData()
  }, [])

  const finalValue = value ?? internalValue

  const mapData = (data) => {
    if (!data) {
      return []
    }
    return data.map((item) => ({label: item.Naziv, value: item.Id.toString()}))
  }

  return (
    <SearchableSelect
      options={kvalitetMaterijalaDropdown}
      value={finalValue?.toString() ?? ''}
      onChange={onChange!}
      name={selectName ?? 'kvalitetMaterijalaDropdown'}
      errors={errors}
      placeholder='Odaberi Kvalitet Materijala.'
      touched={touched}
      disabled={!!disabled}
    />
  )
}

export default KvalitetMaterijalaDropdown
